import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

// Bouton de partage : partage natif (mobile) si dispo, sinon menu
// Copier le lien / WhatsApp / Facebook / X.
const ShareButton = ({ title = 'Recette Tartina', text = '', url }) => {
  const shareUrl = url || (typeof window !== 'undefined' ? window.location.href : '');
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  const handleClick = async () => {
    if (typeof navigator !== 'undefined' && navigator.share) {
      try {
        await navigator.share({ title, text, url: shareUrl });
      } catch (_) {
        /* l'utilisateur a annulé : on ne fait rien */
      }
    } else {
      setOpen((v) => !v);
    }
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (_) {
      /* clipboard indisponible */
    }
  };

  const enc = encodeURIComponent;
  const links = [
    { key: 'wa', icon: 'ti ti-brand-whatsapp', label: 'WhatsApp', href: `https://wa.me/?text=${enc(`${title} — ${shareUrl}`)}` },
    { key: 'fb', icon: 'ti ti-brand-facebook', label: 'Facebook', href: `https://www.facebook.com/sharer/sharer.php?u=${enc(shareUrl)}` },
    { key: 'x', icon: 'ti ti-brand-x', label: 'X', href: `https://twitter.com/intent/tweet?text=${enc(title)}&url=${enc(shareUrl)}` },
  ];

  return (
    <Wrap ref={wrapRef}>
      <Btn type="button" onClick={handleClick} aria-haspopup="menu" aria-expanded={open}>
        <i className="ti ti-share" aria-hidden="true" /> Partager
      </Btn>

      {open && (
        <Menu role="menu">
          <Item as="button" type="button" onClick={copyLink}>
            <i className={copied ? 'ti ti-check' : 'ti ti-link'} aria-hidden="true" />
            {copied ? 'Lien copié !' : 'Copier le lien'}
          </Item>
          {links.map((l) => (
            <Item
              key={l.key}
              href={l.href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
            >
              <i className={l.icon} aria-hidden="true" /> {l.label}
            </Item>
          ))}
        </Menu>
      )}
    </Wrap>
  );
};

const Wrap = styled.div`
  position: relative;
  display: inline-block;
`;
const Btn = styled.button`
  display: inline-flex; align-items: center; gap: 8px; cursor: pointer;
  border: 2px solid ${({ theme }) => theme.colors.primary};
  background: #fff; color: ${({ theme }) => theme.colors.primary};
  border-radius: 999px; padding: 11px 22px; font-weight: 800; font-size: 1rem;
  transition: all .2s ease;
  &:hover { background: ${({ theme }) => theme.colors.primary}; color: #fff; transform: translateY(-2px); }
  i { font-size: 1.15rem; }
`;
const Menu = styled.div`
  position: absolute; z-index: 30; top: calc(100% + 8px); left: 0;
  min-width: 200px; background: #fff;
  border: 1px solid ${({ theme }) => theme.colors.border}; border-radius: 16px;
  box-shadow: ${({ theme }) => theme.shadows.lg}; padding: 8px; overflow: hidden;
`;
const Item = styled.a`
  display: flex; align-items: center; gap: 10px; width: 100%;
  text-decoration: none; cursor: pointer; text-align: left;
  background: transparent; border: none; font-family: inherit;
  color: ${({ theme }) => theme.colors.chocolate}; font-weight: 700; font-size: 0.95rem;
  padding: 10px 12px; border-radius: 10px;
  i { font-size: 1.2rem; color: ${({ theme }) => theme.colors.primary}; }
  &:hover { background: ${({ theme }) => theme.colors.background}; }
`;

export default ShareButton;
